import { useState } from "react";

import { Button, ErrorPage, PageLayout } from "@ezmid/components-library";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { useGetBackOfficeGetCourseQuery } from "../../../api/courses.generated";
import { ParamId } from "../../../enums/types";
import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";
import { CourseDetailPageContent } from "../organisms/CourseDetailPageContent";

export function CourseDetailPage() {
  const { id }: ParamId = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const {
    isFetching,
    currentData,
    isError,
    refetch: courseRefetch,
  } = useGetBackOfficeGetCourseQuery({
    id: id ?? "",
  });
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const langCode = i18n.language.split("-")[0];
  const courseTranslation = currentData?.translations?.find(
    (translation) => translation?.language === langCode
  );
  return isError ? (
    <ErrorPage
      errorMessageText={t("app.page.error.page.not.found")}
      messageForUser={t("app.page.error.defaultMessage")}
      hasGoBackButton
      buttonText={t("app.goToDasboard")}
      onButtonClick={() => navigate(makeRoute(AllRoutes.DASHBOARD))}
    />
  ) : (
    <PageLayout
      title={courseTranslation?.name || ""}
      navigation={
        <div className="mr-2 flex gap-2">
          <Button
            type="button"
            onClick={() => navigate(makeRoute(AllRoutes.COURSES_LIST))}
          >
            {t("button.back")}
          </Button>
          <Button
            onClick={() => {
              setIsModalOpen(true);
            }}
            leftIcon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t("app.lesson.create")}
          </Button>
        </div>
      }
    >
      <CourseDetailPageContent
        currentData={currentData}
        isFetching={isFetching}
        id={id}
        courseRefetch={courseRefetch}
        isModalOpen={isModalOpen}
        onModalClose={() => {
          setIsModalOpen(false);
        }}
      />
    </PageLayout>
  );
}
